import React, { ReactNode } from 'react';
import { OverlayTrigger, Tooltip as TT } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/Overlay';

export type TooltipProps = {
  text: string | ReactNode;
  placement?: Placement;
  wrap?: boolean;
  className?: string;
};

const Tooltip: React.FunctionComponent<TooltipProps> = ({ text, children, placement, wrap, className }) => (
  <OverlayTrigger
    placement={placement || 'auto'}
    overlay={
      <TT className={className} id={`idx-${Math.random()}`}>
        {text}
      </TT>
    }
    delay={{ show: 500, hide: 0 }}
    popperConfig={{
      modifiers: {
        preventOverflow: {
          enabled: false,
        },
        hide: {
          enabled: false,
        },
      },
    }}
  >
    {wrap ? <span>{children}</span> : children}
  </OverlayTrigger>
);

Tooltip.defaultProps = {
  placement: 'top',
};
export default Tooltip;
